// 각 페이지 상단(HeroSection) 배경 이미지의 최적화 버전
// - webp: 원본을 가로 최대 1920px WebP로 변환한 파일 (원본 대비 약 1/3~1/11 용량)
// - placeholder: 진짜 이미지가 오기 전에 바로 보여줄 아주 작은(24px) 흐린 미리보기
// 새 배경을 추가할 때 여기에 없으면 원본 이미지가 그대로 쓰임

export const HERO_IMAGES = {
  '/assets/치과소개_대기실.jpg': {
    webp: '/assets/치과소개_대기실.webp',
    placeholder: 'data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAAAwBACdASoYAAoAPtFWo0uoJKMhsAgBABoJZwAD5aGA47njakClofzPYAAA/uGnRNYu/O7FUcmob+HHgVl+stOe3AtxREZz+GzUCwPXPe5Bhwtli9mcztL7jVax/929KnyTiUw924Jo4GSmt651Th21IoLpYdYjJBxEFt0nP32LdzEHQQZczgUd7LwAAA==',
  },
  '/assets/자연치아배경.png': {
    webp: '/assets/자연치아배경.webp',
    placeholder: 'data:image/webp;base64,UklGRuIAAABXRUJQVlA4WAoAAAAQAAAAFwAADQAAQUxQSBIAAAABD3D1/4iIIBBIQp9/goj+B21WUDggqgAAAFAEAJ0BKhgADgA+0VSjS6gkoyGwCAEAGgljAMKBjCbtAc35KpWOJS/GWQAA/pO+3nBS6olPV4XfguzLnjMtKsAS39kroigsme+p3rz4YFf6C5C7IMy99yq7RorRnJ3X7Far5Bq9d7wq+d/v0/fnKb8zl4INd4d/HVzw+vi5yeIaw24CX15/v30tAXOJksRGvc14rb80gRg0u6Dqe2Wf2kvf1xkN9R8qgAAA',
  },
  '/assets/앞니자신감배경.png': {
    webp: '/assets/앞니자신감배경.webp',
    placeholder: 'data:image/webp;base64,UklGRtgAAABXRUJQVlA4IMwAAABwBQCdASoYABQAPtFcp04oJSOiKAqpABoJZQDM0YwmdFfSUVH3EicEEgJO5B8zEuaR5ybAAP609KX1Wupjt9ozsgneE8/8SdMwVKOM8BIDjjmGsaoOarIVBanP7J5P4x4hZndBY9Ne3f7AK9cZoEfR4gUgVzIMinlzi+oDyEZWXIiday9eVUEsqhyHCa91WdQic/bAPgEXM0PA30IynFSN+orP7VDd+Oj6ZZcgGp7qGKv+6ypHdhYeMlfEQz4v+5lOIFUH9p/PYbbwAAA=',
  },
  '/assets/임플란트배경.png': {
    webp: '/assets/임플란트배경.webp',
    placeholder: 'data:image/webp;base64,UklGRqwAAABXRUJQVlA4IKAAAAAQBACdASoYAA4APtFUo0uoJKMhsAgBABoJZwAD5hncZc4yWLmF8iAx4AD+mWZnI0y8Zh7knqozWAWBlqwnlt73HkYEYn2sgVSlLuULTxKmkN46fWaAtUha9OzD8Rq8Y03xdfP4N1ccKV8syeA+U28hcPgHi/wxOuNLlsiYdL3NbyZ7YNQvSj1In7+IvTBuX3bnVwv57GaaHaCOtu0gAAAA',
  },
  '/assets/교정치료배경.png': {
    webp: '/assets/교정치료배경.webp',
    placeholder: 'data:image/webp;base64,UklGRrgAAABXRUJQVlA4IKwAAAAQBACdASoYABAAPtFUo0uoJKMhsAgBABoJYwC+SYv+3E77n+g2LSH24AD+mEPSC9XOp6u++ovgiLwXbrTKHHVfV8Uy5PlCrjh8GraiLVtSN8/us3XazGQJYCw5DpRP7Xi88cwag9djPEK0aN/0DN492/QZHBS8XDQjvaSEDr5DVQAB9uQghAphP1r3n/rYk4XRNnRC78DAbEYwy2DWJsGHeXcqPmheZPS1IAAA',
  },
  '/assets/어린이치료배경.jpg': {
    webp: '/assets/어린이치료배경.webp',
    placeholder: 'data:image/webp;base64,UklGRrQAAABXRUJQVlA4IKgAAACQBACdASoYABAAPtFUo0uoJKMhsAgBABoJZwDCgYv05fuldtT+YZGOeADGMAAA/ryfoqvkbweNe3q/b5tTYYB9ZuQ/d9L9xx+IvLFncQVATWw2JXNbjPjC5J8CebiyuW5rNMIy1xC0JpLLPGniIaOOxLIYbisyVhmyih3aCRzR6da2LRtfFw1kOvtqG9KQb6iNH+jzG+ZzyzUEdtF6Jsq6bSsWol2AAAA=',
  },
};
